export default {
  heroSection: {
    title: {
      en: 'You’re in!',
    },
    email: {
      en: 'A confirmation email has been sent to <span class="text-bold">{email}</span>.',
    },
  },
  timerSection: {
    title: {
      en: 'What’s next...',
    },
    description: {
      en: `
        Add a products in the next 12 hours to lock in
        everything you want to try in the coming months!
      `,
    },
  },
  upgradeSection: {
    title: {
      en: 'Want to get a perfume even cheaper?',
    },
    description: {
      en: 'Upgrade to two or three bottles a month to discover more scents and save money',
    },
  },
  bottomSection: {
    title: {
      en: 'Discover a complete catalogue of products',
    },
    buttonTitle: {
      en: 'Explore now',
    },
  },
}
